/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_vendor_alibaba': {
    width: 22,
    height: 14,
    viewBox: '0 0 22 14',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M-1-5h24v24H-1z"/><g _fill="#373C41"><path pid="1" d="M8.897 11.846L3.955 10.74a1.07 1.07 0 0 1-.81-1.003c-.002-.014-.002-5.462 0-5.475.02-.49.359-.896.81-1.004l4.942-1.104L9.427 0h-5.76C1.648 0 .009 1.68 0 3.755v6.49C.008 12.321 1.648 14 3.668 14h5.76l-.531-2.154zM13.104 11.846l4.942-1.105c.45-.108.79-.513.81-1.003.002-.014.002-5.462 0-5.475a1.07 1.07 0 0 0-.81-1.004l-4.942-1.104L12.574 0h5.76c2.02 0 3.659 1.68 3.666 3.755v6.49C21.993 12.321 20.353 14 18.333 14h-5.76l.53-2.154z"/><path pid="2" d="M9 7.5h4v-1H9z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_vendor_alibaba.js